import firebase from "firebase/app";
import "firebase/storage";
import User from "@/models/User.js";

const database = firebase.database();
const settings = {
	timestampsInSnapshots: true,
};
const loadFirestore = () => {
	var db = firebase.firestore();
	return db.collection("cerberus_PositionRecord").get();
};
const getResourceTracking = async (positionrecordId, companyId) => {
	const starCountRef = database.ref("tracking/" + companyId + "/" + positionrecordId);
	starCountRef.on("value", (snapshot) => {
		const data = snapshot.val();
	});
};
/**
 *
 * @param {File} filed is file to got forn input type file
 * @param {*} path is the directory path of the firebase
 * @returns
 */
const uploadFileToFirebase = async function (filed, path) {
	const that = this;
	const user = new User();
	const userInfo = await user.getUser();
	return new Promise(function (resolve, reject) {
		// Create a root reference
		const storageRef = firebase.storage().ref();
		// File or Blob named mountains.jpg
		const file = filed;
		// Create the file metadata
		const metadata = {
			contentType: file.type,
		};
		// create unique identify date
		const uniqueId = new Date().getTime();
		// Upload file and metadata to the object 'images/mountains.jpg'
		const uploadTask = storageRef
			.child(`${userInfo.company_id}${path}${uniqueId}-${file.name}`)
			.put(file, metadata);
		// Listen for state changes, errors, and completion of the upload.
		uploadTask.on(
			firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
			function (snapshot) {
				// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
				let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				that.progressPercent = progress;
				switch (snapshot.state) {
					case firebase.storage.TaskState.PAUSED: // or 'paused'
						break;
					case firebase.storage.TaskState.RUNNING: // or 'running'
						break;
				}
			},
			function (error) {
				// A full list of error codes is available at
				switch (error.code) {
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect error.serverResponse
						break;
				}
				reject(error);
			},
			function () {
				// Upload completed successfully, now we can get the download URL
				uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
					const urls = {
						downloadURL,
						bucketPath: `${userInfo.company_id}${path}${uniqueId}-${file.name}`,
					};
					resolve(urls);
				});
			}
		);
	});
};
const downloadFileFromFirebase = async function (path) {
	const user = new User();
	const userInfo = await user.getUser();
	return new Promise(function (resolve, reject) {
		// Create a root reference
		const storageRef = firebase.storage().ref();
		// Create a reference to the file we want to download
		const starsRef = storageRef.child(path);
		// Get the download URL
		starsRef
			.getDownloadURL()
			.then(function (url) {
				// Insert url into an <img> tag to "download"
				resolve(url);
			})
			.catch(function (error) {
				// A full list of error codes is available at
				switch (error.code) {
					case "storage/object-not-found":
						// File doesn't exist
						break;
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect the server response
						break;
				}
				reject(error);
			});
	});
};
const downloadFileFromStorage = function (gsPath) {
	return new Promise(function (resolve, reject) {
		// Create a root reference
		var storage = firebase.storage();
		var gsReference = storage.refFromURL(gsPath);
		// Get the download URL
		gsReference
			.getDownloadURL()
			.then(function (url) {
				// Insert url into an <img> tag to "download"
				resolve(url);
			})
			.catch(function (error) {
				// A full list of error codes is available at
				switch (error.code) {
					case "storage/object-not-found":
						// File doesn't exist
						break;
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect the server response
						break;
				}
				reject(error);
			});
	});
};
const getFirebaseMessageByResourceId = function (resourceid) {
	return new Promise(function (resolve, reject) {
		// Create a root reference
		const database = firebase.database();
		const starCountRef = database.ref(`messages/${resourceid}`).orderByChild("date");
		try {
			starCountRef.once("value", (snapshot) => {
				const messages = [];
				snapshot.forEach((childSnapshot) => {
					// key will be "ada" the first time and "alan" the second time
					let key = childSnapshot.key;
					// childData will be the actual contents of the child
					let childData = {...childSnapshot.val(), id: key};
					messages.push(childData);
				});
				resolve(messages);
			});
		} catch (error) {
			reject(error);
		}
	});
};
const updateFirebaseMessage = async function (message) {
	const user = new User();
	const userInfo = await user.getUser();
	return new Promise(function (resolve, reject) {
		// Create a root reference
		const {key} = {...message};
		delete message.key;
		const database = firebase.database();
		database.ref(`messages/${userInfo.company_id}/${message.resource_id}/${key}`).set(message);
		//ref("PIN/`-KrnO...Ho/PIN").set(30);
		try {
			resolve({message});
		} catch (error) {
			reject(error);
		}
	});
};
const deleteFireabseMessage = async function (message) {
	const user = new User();
	const userInfo = await user.getUser();
	return new Promise(function (resolve, reject) {
		// Create a root reference
		const {key} = {...message};
		delete message.key;
		const database = firebase.database();
		database
			.ref(`messages/${userInfo.company_id}/${message.resource_id}/${key}`)
			.remove()
			.then(function () {
				resolve({message: "Remove succeeded."});
			})
			.catch(function (error) {
				reject(error);
			});
	});
};
const sendFirebaseResourceNotifications = function (notification, resourceId, eventId) {
	return new Promise(async function (resolve, reject) {
		try {
			const user = new User();
			const userInfo = await user.getUser();
			await firebase
				.database()
				.ref(`notification/${userInfo.company_id}/movil/${resourceId}/${eventId}`)
				.set(notification);
			resolve({notification});
		} catch (error) {
			reject(error);
		}
	});
};
const uploadCompanyLogo = async function (filed, path) {
	const that = this;

	return new Promise(function (resolve, reject) {
		// Create a root reference
		const storageRef = firebase.storage().ref();
		// File or Blob named mountains.jpg
		const file = filed;
		// Create the file metadata
		const metadata = {
			contentType: file.type,
		};
		// create unique identify date
		const uniqueId = new Date().getTime();
		// Upload file and metadata to the object 'images/mountains.jpg'
		const uploadTask = storageRef.child(`${path}${uniqueId}-${file.name}`).put(file, metadata);
		// Listen for state changes, errors, and completion of the upload.
		uploadTask.on(
			firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
			function (snapshot) {
				// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
				let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				that.progressPercent = progress;
				switch (snapshot.state) {
					case firebase.storage.TaskState.PAUSED: // or 'paused'
						break;
					case firebase.storage.TaskState.RUNNING: // or 'running'
						break;
				}
			},
			function (error) {
				// A full list of error codes is available at
				switch (error.code) {
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect error.serverResponse
						break;
				}
				reject(error);
			},
			function () {
				// Upload completed successfully, now we can get the download URL
				uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
					const urls = {
						downloadURL,
						bucketPath: `${path}${uniqueId}-${file.name}`,
					};
					resolve(urls);
				});
			}
		);
	});
};

const deleteFileToFirebase = async function (path, fileName) {
	const user = new User();
	const userInfo = await user.getUser();
	const storageRef = firebase.storage().ref();
	// Create a reference to the file to delete
	const desertRef = await storageRef.child(`${userInfo.company_id}${path}${fileName}`);
	await desertRef.getDownloadURL().then(() => {
		desertRef
			.delete()
			.then(() => {
				return {message: "Remove succeeded."};
			})
			.catch((error) => {
				throw new Error(error);
			});
	});
};

const removeFileFromFirebase = function (bucketPath) {
	return new Promise(async (resolve, reject) => {
		const storageRef = firebase.storage().ref();
		// Create a reference to the file to delete
		const desertRef = storageRef.child(bucketPath);
		try {
			// Delete the file
			await desertRef.delete();
			resolve("File deleted");
		} catch (error) {
			reject(new Error("Error delete"));
		}
	});
};

const listAllFilesFromFirebaseFolder = (folderName) => {
	return new Promise(async (resolve, reject) => {
		const storageRef = firebase.storage().ref();
		// Create a reference under which you want to list
		const listRef = storageRef.child(folderName);
		try {
			// Find all the prefixes and items.
			const listFiles = await listRef.listAll();
			if (listFiles.items.length > 0) {
				resolve(listFiles.items);
			} else {
				resolve([]);
			}
		} catch (error) {
			reject(new Error("Error delete"));
		}
	});
};

export {
	loadFirestore,
	getResourceTracking,
	uploadFileToFirebase,
	downloadFileFromFirebase,
	downloadFileFromStorage,
	getFirebaseMessageByResourceId,
	updateFirebaseMessage,
	deleteFireabseMessage,
	sendFirebaseResourceNotifications,
	uploadCompanyLogo,
	deleteFileToFirebase,
	removeFileFromFirebase,
	listAllFilesFromFirebaseFolder,
};
